import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { IonIcon, IonLabel, IonMenu, IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'
import { addIcons } from 'ionicons'
import { cashOutline, diamondOutline, documentTextOutline, homeOutline, star } from 'ionicons/icons'

import { DrawerComponent } from '../../shared/components/drawer/drawer.component'
import { DisplayService } from '../../shared/services/display.service'

@Component({
	selector: 'app-tabs',
	templateUrl: 'tabs.page.html',
	styleUrls: ['tabs.page.scss'],
	standalone: true,
	imports: [IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel, IonMenu, FormsModule, DrawerComponent, TranslatePipe],
})
export class TabsPage {
	constructor(private readonly displayService: DisplayService) {
		addIcons({ star, homeOutline, cashOutline, documentTextOutline, diamondOutline })
	}

	openCasino() {
		this.displayService.openCasino()
	}
}
